export default __webpack_public_path__ + "static/media/consultpattern.8814b7d9.png";